/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Sign Up components
 */

import React from 'react';

import HeaderFooterwithCookies from '../../../common/openPages/HeaderFooterwithCookies';

import ConfirmPassword from './ConfirmPassword';

function ConfirmPasswordIndex(props) {
  const { passwordExpired } = props;
  return (
    <HeaderFooterwithCookies cookiesEnabled>
      <ConfirmPassword passwordExpired={passwordExpired} />
    </HeaderFooterwithCookies>
  );
}

export default ConfirmPasswordIndex;
